import { Handle, Position } from '@xyflow/react'

const PARAMS = [
  { field: 'minInterval', label: 'Min Interval', min: 0.5, max: 20, step: 0.5, unit: 's', def: 2 },
  { field: 'maxInterval', label: 'Max Interval', min: 1,   max: 30, step: 0.5, unit: 's', def: 6 },
  { field: 'closeMs',     label: 'Close',        min: 10,  max: 500, step: 10, unit: 'ms', def: 80 },
  { field: 'holdMs',      label: 'Hold',         min: 0,   max: 300, step: 10, unit: 'ms', def: 40 },
  { field: 'openMs',      label: 'Open',         min: 10,  max: 500, step: 10, unit: 'ms', def: 100 },
]

export function BlinkNode({ data, selected }) {
  const vals = {}
  for (const p of PARAMS) vals[p.field] = data[p.field] ?? p.def

  return (
    <div style={{
      background: selected ? '#1a1f2a' : '#10141e',
      border: `2px solid ${selected ? '#40a0e0' : '#2a4870'}`,
      borderRadius: 6,
      padding: '10px 14px',
      minWidth: 200,
      color: '#ddd',
      fontFamily: 'var(--m-font)',
      fontSize: 12,
    }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginBottom: 10 }}>
        <span style={{ fontSize: 14 }}>👁</span>
        <span style={{ color: '#80c8e8', fontWeight: 'bold', fontSize: 11 }}>BLINK</span>
      </div>

      {PARAMS.map(({ field, label, min, max, step, unit }) => (
        <div key={field} style={{ display: 'flex', alignItems: 'center', marginBottom: 4, position: 'relative' }}>
          <Handle
            type="target"
            position={Position.Left}
            id={`in-${field}`}
            style={{ background: '#4ecf7e', width: 7, height: 7, top: '50%', transform: 'translateY(-50%)' }}
          />
          <span style={{ color: '#708898', fontSize: 10, flex: 1, marginLeft: 12 }}>{label}</span>
          <input
            type="number"
            min={min} max={max} step={step}
            value={vals[field]}
            onChange={e => data.onChange?.(field, parseFloat(e.target.value))}
            onMouseDown={e => e.stopPropagation()}
            style={{
              width: 48, boxSizing: 'border-box',
              background: '#0a1520', border: '1px solid #1f3850',
              color: '#9ad0f0', padding: '2px 4px',
              borderRadius: 3, fontSize: 10, fontFamily: 'var(--m-mono)', outline: 'none',
            }}
          />
          <span style={{ color: '#405060', fontSize: 9, width: 16, textAlign: 'right' }}>{unit}</span>
        </div>
      ))}

      <div style={{ color: '#384858', fontSize: 9, marginTop: 6 }}>
        Total: {vals.closeMs + vals.holdMs + vals.openMs}ms · Every {vals.minInterval.toFixed(1)}–{vals.maxInterval.toFixed(1)}s
      </div>

      <Handle
        type="source"
        position={Position.Right}
        id="anim"
        style={{ background: '#e07040', width: 10, height: 10 }}
      />
    </div>
  )
}
